import React  from 'react';
import {FieldViewProps} from "../../../../render/view";

export default function FieldDateRange_ViewSmall(props:FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    const classes = Classes("ui5-txt-less-important-small txt-truncate", props.className)

    return (
        <div className={classes}>
            {props.field.getDisplayValue(value)}
        </div>
    );
}
